export default [
    {
        key: "elektropanel",
        allArray: "allElektropanelTelezhka",
        activeArray: "activeElektropanelTelezhka",
        position: "top",
    },
];
